"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubReactionChuteBrusqueValeurInvestissementTrads = void 0;
exports.ESubReactionChuteBrusqueValeurInvestissementTrads = {
    conserver: "Vous les conservez dans une politique de long terme",
    investir: "Vous en profitez pour investir",
    vendre: "Vous les vendez afin de limiter vos pertes",
};
